import React from "react";
import { useNavigate } from "react-router-dom";
import "./Mobile.css";

function Mobile() {
    const navigate = useNavigate();

    const handleSignIn = () => {
        navigate("/sign-in");
    };

    const handleSignNDA = () => {
        navigate("/sign-nda");
    };

    return (
        <div className="mobile-home">
            <main className="mobile-main">
                <div className="mobile-content">
                    <img
                        src="/logo_SDBLACK.png"
                        alt="Sound Disposition"
                        className="mobile-logo"
                    />
                    <h1 className="mobile-title">Welcome to Sound Disposition</h1>
                    <div className="mobile-button-container">
                        <button
                            className="mobile-portal-button"
                            onClick={handleSignIn}
                        >
                            Visitor Sign In
                        </button>
                        <button
                            className="mobile-portal-button"
                            onClick={handleSignNDA}
                        >
                            Sign NDA
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Mobile;
